// test2474
(2474 && 0);
